exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".control-tab[data-v-3cd5a314] {\n  font-size: 14px;\n  color: #2B303A;\n  padding: 5px 3px;\n  background: transparent;\n  outline: none;\n  border-bottom: 2px solid transparent;\n  display: inline-block;\n}\n.control-tab[data-v-3cd5a314]:hover {\n  opacity: 0.3;\n  color: #bec0c2;\n}\n.control-tab.is-active[data-v-3cd5a314] {\n  color: #21A9E1;\n  border-bottom: 2px solid #21A9E1;\n}\n.control-tab.is-active[data-v-3cd5a314]:hover {\n  opacity: 1;\n  cursor: initial;\n}", ""]);

// exports
